import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["aria-label", "checkBoxClass", "className", "color", "checked", "onChange", "label", "labelPlacement", "inputProps"];
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Checkbox as MuiCheckbox, FormControl as MuiFormControl, FormControlLabel as MuiFormControlLabel } from '@mui/material';
import useStyles from './Checkbox.styles';
var Checkbox = function Checkbox(props) {
  var ariaLabel = props['aria-label'],
    checkBoxClass = props.checkBoxClass,
    className = props.className,
    color = props.color,
    checked = props.checked,
    onChange = props.onChange,
    label = props.label,
    labelPlacement = props.labelPlacement,
    inputProps = props.inputProps,
    other = _objectWithoutProperties(props, _excluded);
  var _useState = useState(checked),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var handleChange = function handleChange(event) {
    setIsChecked(event.target.checked);
    if (onChange && typeof onChange === 'function') {
      onChange(event);
    }
  };
  useEffect(function () {
    setIsChecked(checked);
  }, [checked]);
  var inputAriaLabel = inputProps['aria-label'] || typeof label === 'string' && label;
  return /*#__PURE__*/React.createElement(MuiFormControl, {
    className: cx(_defineProperty({}, classes.primary, color === 'primary'), classes.root, className),
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(MuiFormControlLabel, {
    control: /*#__PURE__*/React.createElement(MuiCheckbox, _extends({
      "aria-label": ariaLabel,
      className: checkBoxClass,
      checked: isChecked,
      onChange: handleChange,
      color: color,
      inputProps: _extends({}, inputProps, {
        'aria-label': inputAriaLabel
      })
    }, other)),
    label: label,
    labelPlacement: labelPlacement
  }));
};
process.env.NODE_ENV !== "production" ? Checkbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelPlacement: PropTypes.oneOf(['top', 'end', 'bottom', 'start']),
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),
  size: PropTypes.oneOf(['small', 'medium']),
  inputProps: PropTypes.object
} : void 0;
Checkbox.defaultProps = {
  color: 'primary',
  labelPlacement: 'end',
  size: 'medium',
  inputProps: {}
};
export default Checkbox;